export function applyFeatureFlagOverrideFromUrl(cookies, search) {
    const override = new URLSearchParams(search).get('ff');
    cookies.setCookie('ff', override || '');
}
